class SearchAccountingEntriesReq{

    constructor() {
  
      this.id = undefined;
      this.fromAmount = undefined;
      this.toAmount = undefined;
      this.title = undefined;
      this.description = undefined;
      this.category = undefined;
      this.entryType = undefined;
      this.employeeId = undefined;
      this.facilityId = undefined;
      this.isProfit = undefined;
      this.patientId = undefined;
      this.accountingSessionId = undefined;
      this.therapistId = undefined
      this.accountingTherapistHourId = undefined;
      this.fromDate = undefined
      this.toDate = undefined
      this.userId = undefined;
      this.packageId = undefined;
      this.creatorId = undefined;
      this.pagingParams = {
        pageNumber: undefined,
        pageSize: undefined
      }
  
      
    }
  }
  export default SearchAccountingEntriesReq;